import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { getDeliverables, getFileUrl, getWorkPackages } from '../services/apiService';
import './WorkPackages.css';

const Deliverables = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [deliverables, setDeliverables] = useState([]);
  const [workPackages, setWorkPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredDeliverables, setFilteredDeliverables] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [wpFilter, setWpFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1360);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Récupérer les deliverables et work packages depuis l'API
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Récupérer les deliverables
        const data = await getDeliverables();
        console.log('Tous les deliverables reçus:', data?.length || 0);
        console.log('Exemples de statuts:', data?.slice(0, 5).map(d => ({ id: d.id, status: d.status })));
        
        // Filtrer uniquement les deliverables terminés
        const completedDeliverables = (data || []).filter(d => {
          const status = d.status?.toLowerCase();
          return status === 'completed';
        });
        
        setDeliverables(completedDeliverables);
        
        // Récupérer les work packages pour le filtre
        const wps = await getWorkPackages();
        console.log('Work packages reçus:', wps?.length || 0);
        console.log('Exemples de work packages:', wps?.slice(0, 5).map(wp => ({ id: wp.id, title: wp.title })));
        setWorkPackages(wps || []);
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setError('Erreur lors du chargement des deliverables');
        setDeliverables([]);
        setWorkPackages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filtrer les deliverables selon les critères de recherche et filtres
  useEffect(() => {
    let filtered = [...deliverables];

    // Filtre par Work Package
    if (wpFilter) {
      filtered = filtered.filter(d => d.wp === wpFilter);
    }

    // Filtre par terme de recherche
    if (searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(deliverable => {
        return (
          deliverable.id?.toLowerCase().includes(searchLower) ||
          deliverable.description?.toLowerCase().includes(searchLower) ||
          deliverable.wp?.toLowerCase().includes(searchLower) ||
          deliverable.lead?.toLowerCase().includes(searchLower) ||
          deliverable.date?.toLowerCase().includes(searchLower)
        );
      });
    }

    setFilteredDeliverables(filtered);
    setCurrentPage(1);
  }, [searchTerm, wpFilter, deliverables]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDeliverables = filteredDeliverables.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDeliverables.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#10b981';
      case 'in_progress':
        return '#3b82f6';
      case 'pending':
      default:
        return '#f59e0b';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed':
        return t('deliverables.status.completed', 'Completed');
      case 'in_progress':
        return t('deliverables.status.inProgress', 'In Progress');
      case 'pending':
      default:
        return t('deliverables.status.pending', 'Pending');
    }
  };

  return (
    <>
      <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059">
        <div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type">
          <div class="jet-theme-core-document__inner">
	
	<Navbar/>
	
	{/* Composant de test des icônes FontAwesome */}
	
	<article id="post-4059" class="post-4059 page type-page status-publish hentry">	
			<div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
				<section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;5759a04&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
					<div className="elementor-container elementor-column-gap-default">
						<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
							<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-settings="{&quot;slider_height&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:852,&quot;sizes&quot;:[]},&quot;_animation&quot;:&quot;none&quot;,&quot;slider_height_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:650,&quot;sizes&quot;:[]},&quot;slider_height_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:500,&quot;sizes&quot;:[]}}" data-widget_type="jet-slider.default">
									<div class="elementor-widget-container">
										<div class="elementor-jet-slider jet-elements">
                        <div style={{ 
                          position: 'relative', 
                          width: '100%', 
                          height: isMobile ? 'auto' : 'auto', 
                          minHeight: isMobile ? '400px' : '500px',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: isMobile ? '100px 20px 40px' : '80px 20px 40px',
                          background: 'linear-gradient(135deg, rgba(46,134,171,0.8) 0%, rgba(25,118,157,0.8) 50%, rgba(40,167,69,0.8) 100%), url("https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1920&h=1080&fit=crop") center/cover no-repeat'
                        }}>
                          {/* Text Content */}
                          <div style={{ 
                            width: '100%',
                            maxWidth: '1200px',
                            marginBottom: '40px'
                          }}>
                            <div style={{
                              maxWidth: isMobile ? '100%' : '800px',
                              margin: '0 auto',
                              textAlign: 'center'
                            }}>
                              <h1 style={{ 
                                color: '#fff', 
                                fontSize: isMobile ? 'clamp(28px,3vw,42px)' : 'clamp(32px,4.5vw,54px)', 
                                fontWeight: '800', 
                                margin: '0 0 20px 0', 
                                letterSpacing: '-0.02em',
                                lineHeight: '1.1',
                                textAlign: 'center'
                              }}>
                                {t('deliverables.title', 'Completed Deliverables')}
                              </h1>
                              <p style={{ 
                                color: '#fff', 
                                fontSize: isMobile ? 'clamp(16px,2vw,20px)' : 'clamp(18px,2.5vw,22px)', 
                                fontWeight: '400', 
                                margin: '0', 
                                lineHeight: '1.6',
                                textAlign: 'center',
                                textShadow: '0 1px 4px rgba(0,0,0,0.2)',
                                opacity: 0.95
                              }}>
                                {t('deliverables.subtitle', 'Access and download completed project deliverables')}
                              </p>
                            </div>
                          </div>

                          {/* Filters Section */}
                          <div style={{
                            width: '100%',
                            maxWidth: '1200px',
                            background: 'rgba(255, 255, 255, 0.95)',
                            padding: isMobile ? '16px' : '24px',
                            borderRadius: '12px',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                            backdropFilter: 'blur(10px)'
                          }}>
                            {/* Search and Work Package Filter - Same Line */}
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
                              gap: isMobile ? '12px' : '16px',
                              marginBottom: (searchTerm || wpFilter) ? '16px' : '0'
                            }}>
                              {/* Search Bar */}
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                background: '#f8f9fa',
                                padding: '0px 16px',
                                borderRadius: '8px',
                                border: '2px solid #e9ecef'
                              }}>
                                <i className="fas fa-search" style={{ color: '#96ca2d', fontSize: '1.1rem' }}></i>
                                <input
                                  type="text"
                                  placeholder={t('deliverables.searchPlaceholder', 'Search by ID, description, work package, lead, or date...')}
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  style={{
                                    flex: 1,
                                    border: 'none',
                                    background: 'transparent',
                                    fontSize: '1rem',
                                    outline: 'none',
                                    color: '#495057'
                                  }}
                                />
                                {searchTerm && (
                                  <button
                                    onClick={() => setSearchTerm('')}
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      color: '#6c757d',
                                      cursor: 'pointer',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = '#e9ecef';
                                      e.currentTarget.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = 'transparent';
                                      e.currentTarget.style.color = '#6c757d';
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                )}
                              </div>

                              {/* Work Package Filter */}
                              <div style={{ position: 'relative' }}>
                                <select
                                  value={wpFilter}
                                  onChange={(e) => setWpFilter(e.target.value)}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    padding: '12px 40px 12px 16px',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '8px',
                                    fontSize: '0.95rem',
                                    background: 'white',
                                    color: '#495057',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    appearance: 'none',
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23495057\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right 12px center',
                                    backgroundSize: '16px 16px'
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#96ca2d';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(150, 202, 45, 0.1)';
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#e9ecef';
                                    e.target.style.boxShadow = 'none';
                                  }}
                                >
                                  <option value="">{t('deliverables.filter.allWorkPackages', 'All Work Packages')}</option>
                                  {workPackages && workPackages.length > 0 ? (
                                    workPackages
                                      .filter(wp => {
                                        // Filtrer les work packages de Wp0 à Wp8 (format: "Wp0", "Wp1", etc.)
                                        const wpId = wp.id || wp.wpId || '';
                                        if (typeof wpId === 'string') {
                                          // Gérer les formats "Wp0", "Wp1", etc. ou "W0", "W1", etc.
                                          const match = wpId.match(/^Wp?(\d+)$/i);
                                          if (match) {
                                            const num = parseInt(match[1]);
                                            return !isNaN(num) && num >= 0 && num <= 8;
                                          }
                                        }
                                        return false;
                                      })
                                      .sort((a, b) => {
                                        // Trier par numéro (Wp0, Wp1, Wp2, ..., Wp8)
                                        const getId = (wp) => wp.id || wp.wpId || '';
                                        const matchA = getId(a).match(/^Wp?(\d+)$/i);
                                        const matchB = getId(b).match(/^Wp?(\d+)$/i);
                                        const numA = matchA ? parseInt(matchA[1]) : 999;
                                        const numB = matchB ? parseInt(matchB[1]) : 999;
                                        return numA - numB;
                                      })
                                      .map(wp => {
                                        const wpId = wp.id || wp.wpId || '';
                                        return (
                                          <option key={wpId} value={wpId}>{wpId}</option>
                                        );
                                      })
                                  ) : (
                                    // Fallback: générer Wp0 à Wp8 si les work packages ne sont pas chargés
                                    Array.from({ length: 9 }, (_, i) => (
                                      <option key={`Wp${i}`} value={`Wp${i}`}>{`Wp${i}`}</option>
                                    ))
                                  )}
                                </select>
                              </div>
                            </div>

                            {/* Reset Button */}
                            {(searchTerm || wpFilter) && (
                              <button
                                onClick={() => {
                                  setSearchTerm('');
                                  setWpFilter('');
                                }}
                                style={{
                                  width: '100%',
                                  padding: '12px 20px',
                                  background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)',
                                  border: 'none',
                                  borderRadius: '8px',
                                  color: 'white',
                                  fontSize: '0.95rem',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  transition: 'all 0.3s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '8px',
                                  boxShadow: '0 2px 4px rgba(150, 202, 45, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(150, 202, 45, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(150, 202, 45, 0.3)';
                                }}
                              >
                                <i className="fas fa-redo"></i>
                                {t('deliverables.filter.reset', 'Reset Filters')}
                              </button>
                            )}
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
					</div>
          </section>
</div>
                    </article>
                    
                    {/* Main Content Section */}
                    <section style={{ padding: '60px 0' }}>
                      <div style={{
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: '0 20px 60px'
                      }}>
                  {/* Loading State */}
                  {loading && (
                    <div style={{
                      textAlign: 'center',
                      padding: '60px 20px',
                      color: '#6b7280'
                    }}>
                      <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', marginBottom: '20px' }}></i>
                      <p>{t('deliverables.loading', 'Loading deliverables...')}</p>
                    </div>
                  )}

                  {/* Error State */}
                  {error && (
                    <div style={{
                      background: '#fee2e2',
                      border: '1px solid #fecaca',
                      color: '#991b1b',
                      padding: '20px',
                      borderRadius: '8px',
                      marginBottom: '30px',
                      textAlign: 'center'
                    }}>
                      <i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                      {error}
                    </div>
                  )}

                  {/* No Results */}
                  {!loading && !error && filteredDeliverables.length === 0 && (
                    <div style={{
                      textAlign: 'center',
                      padding: '60px 20px',
                      color: '#6b7280'
                    }}>
                      <i className="fas fa-inbox" style={{ fontSize: '3rem', marginBottom: '20px', opacity: 0.5 }}></i>
                      <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>
                        {searchTerm
                          ? t('deliverables.noResults', 'No deliverables found matching your search.')
                          : t('deliverables.noDeliverables', 'No completed deliverables available.')}
                      </p>
                    </div>
                  )}

                  {/* Deliverables Grid */}
                  {!loading && !error && (
                    <>
                      {currentDeliverables.length > 0 && (
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                          gap: '24px',
                          marginBottom: '40px'
                        }}>
                          {currentDeliverables.map((deliverable, index) => (
                            <div
                              key={deliverable.id || deliverable.mongoId || index}
                              style={{
                                background: 'white',
                                padding: '24px',
                                borderRadius: '12px',
                                border: '2px solid #e9ecef',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                                overflow: 'hidden',
                                boxSizing: 'border-box'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                                e.currentTarget.style.borderColor = '#96ca2d';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                                e.currentTarget.style.borderColor = '#e9ecef';
                              }}
                            >
                              {/* Header */}
                              <div style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                                gap: '12px',
                                marginBottom: '8px'
                              }}>
                                <div style={{ flex: 1 }}>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '8px',
                                    flexWrap: 'wrap'
                                  }}>
                                    <span style={{
                                      background: '#f8f9fa',
                                      color: '#96ca2d',
                                      padding: '6px 12px',
                                      borderRadius: '6px',
                                      fontSize: '0.85rem',
                                      fontWeight: '700',
                                      border: '2px solid #96ca2d'
                                    }}>
                                      {deliverable.id}
                                    </span>
                                    {deliverable.wp && (
                                      <span style={{
                                        background: '#e9ecef',
                                        color: '#6c757d',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        fontSize: '0.8rem',
                                        fontWeight: '600'
                                      }}>
                                        {deliverable.wp}
                                      </span>
                                    )}
                                  </div>
                                  <h3 style={{
                                    margin: 0,
                                    fontSize: '1.1rem',
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    lineHeight: '1.4'
                                  }}>
                                    {deliverable.description}
                                  </h3>
                                </div>
                                <span style={{
                                  background: getStatusColor(deliverable.status),
                                  color: 'white',
                                  padding: '6px 12px',
                                  borderRadius: '20px',
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                  textTransform: 'capitalize',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  whiteSpace: 'nowrap',
                                  boxShadow: `0 2px 4px ${getStatusColor(deliverable.status)}40`
                                }}>
                                  <i className="fas fa-check-circle" style={{ fontSize: '0.7rem' }}></i>
                                  {getStatusLabel(deliverable.status)}
                                </span>
                              </div>

                              {/* Details */}
                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                fontSize: '0.9rem',
                                color: '#6b7280'
                              }}>
                                {deliverable.date && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="fas fa-calendar-alt" style={{ color: '#96ca2d', width: '16px' }}></i>
                                    <span><strong>{t('deliverables.date', 'Date')}:</strong> {deliverable.date}</span>
                                  </div>
                                )}
                                {deliverable.lead && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="fas fa-user-tie" style={{ color: '#96ca2d', width: '16px' }}></i>
                                    <span><strong>{t('deliverables.lead', 'Lead')}:</strong> {deliverable.lead}</span>
                                  </div>
                                )}
                              </div>

                              {/* Download Button */}
                              {deliverable.file && (
                                <div style={{ marginTop: 'auto', paddingTop: '12px', borderTop: '1px solid #e9ecef' }}>
                                  <a
                                    href={getFileUrl(deliverable.file)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    title={t('deliverables.download', 'Download File')}
                                    style={{
                                      width: '100%',
                                      maxWidth: '100%',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '8px',
                                      padding: '12px 20px',
                                      background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)',
                                      color: 'white',
                                      borderRadius: '8px',
                                      textDecoration: 'none',
                                      fontWeight: '600',
                                      fontSize: '0.9rem',
                                      transition: 'all 0.3s ease',
                                      boxShadow: '0 2px 4px rgba(150, 202, 45, 0.3)',
                                      boxSizing: 'border-box',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform = 'translateY(-2px)';
                                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(150, 202, 45, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform = 'translateY(0)';
                                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(150, 202, 45, 0.3)';
                                    }}
                                  >
                                    <i className="fas fa-download" style={{ fontSize: '0.9rem' }}></i>
                                    {t('deliverables.download', 'Download File')}
                                  </a>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0, marginTop: '30px', flexWrap: 'wrap' }}>
                          <div style={{ display: 'inline-flex', gap: 0 }}>
                            <button
                              onClick={() => {
                                setCurrentPage(p => Math.max(1, p - 1));
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }}
                              disabled={currentPage === 1}
                              style={{
                                padding: '8px 10px',
                                minWidth: 36,
                                borderRadius: '6px 0 0 6px',
                                border: '1px solid #96ca2d',
                                background: currentPage === 1 ? '#f2f2f2' : '#96ca2d',
                                color: currentPage === 1 ? '#888' : '#fff',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                margin: 0,
                                borderRightWidth: 0
                              }}
                            >&lt;</button>
                            {(() => {
                              const buttons = [];
                              const renderBtn = (i, isFirst = false) => (
                                <button
                                  key={i}
                                  onClick={() => {
                                    setCurrentPage(i);
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                  }}
                                  style={{
                                    padding: '8px 10px',
                                    minWidth: 36,
                                    borderRadius: 0,
                                    border: `1px solid ${currentPage === i ? '#96ca2d' : '#ddd'}`,
                                    background: currentPage === i ? '#96ca2d' : '#fff',
                                    color: currentPage === i ? '#fff' : '#333',
                                    cursor: 'pointer',
                                    margin: 0,
                                    borderLeftWidth: isFirst ? '1px' : 0
                                  }}
                                >
                                  {i}
                                </button>
                              );

                              const shown = Math.min(totalPages, 3);
                              for (let i = 1; i <= shown; i++) {
                                buttons.push(renderBtn(i, i === 1));
                              }
                              if (totalPages > 3) {
                                buttons.push(
                                  <span key="ell" style={{ padding: '8px 6px', border: '1px solid #ddd', borderLeftWidth: 0 }}>...</span>
                                );
                              }
                              return buttons;
                            })()}
                            <button
                              onClick={() => {
                                setCurrentPage(p => Math.min(totalPages, p + 1));
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }}
                              disabled={currentPage === totalPages}
                              style={{
                                padding: '8px 10px',
                                minWidth: 36,
                                borderRadius: '0 6px 6px 0',
                                border: '1px solid #96ca2d',
                                background: currentPage === totalPages ? '#f2f2f2' : '#96ca2d',
                                color: currentPage === totalPages ? '#888' : '#fff',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                margin: 0,
                                borderLeftWidth: 0
                              }}
                            >&gt;</button>
                          </div>
                        </div>
                      )}

                    </>
                  )}
                      </div>
                    </section>
      
          <Footer />
          </div></div></div>
    </>
  );
};

export default Deliverables;

